import React from 'react'
import Banner from '../Components/Home/Banner1'
import About from '../Components/Home/About'
import Services from '../Components/Home/Services'
import Portfolio from '../Components/Home/Portfolio'
import Team from '../Components/Home/Team'
import Clients from '../Components/Home/Clients'
import Pricing from '../Components/Home/Pricing'
import Subscribe from '../Components/Home/Subscribe'
import Blog from '../Components/Home/Blog'
import Support from '../Components/Home/Support'
import Testimonial from '../Components/Home/testimonial'


const Landingpage = () => {
  return (
    <div id="page" class="full-page">
      <Banner />
      <About />
      <Services />
      <Support />
      <Blog />


      {/* <Portfolio /> */}
      {/* <Team /> */}
      {/* <Pricing /> */}
      {/* <Clients /> */}
      {/* <Subscribe /> */}
      {/* <Testimonial /> */}
    </div>
  )
}

export default Landingpage
